import { useOutletContext } from 'react-router-dom'

type Props = {
  setIsDirty: (value: boolean) => void
  setSaved: (value: boolean) => void
  setIsDisabled: (value: boolean) => void
  saved: boolean
  isDirty: boolean
  isDisabled: boolean
  courseValidityToggle: boolean
  setCourseValidityToggle: (value: boolean) => void
}
export const useEditTrainingContext = () => useOutletContext<Props>()
